import { useFetch } from "lib/useFetch";

// convenience fetcher which also calls a parse function to parse data
export function useFetchParse(url, body, method, condition, fParser) {
  let [data, isLoading, error] = useFetch(url, body, method, condition);

  try {
    if (data && !isEmptyArray(data)) {
      data = fParser(data);
    }
  } catch (err) {
    console.error("Error parsing data from url: ", url, data, err);
    error = err;
  }
  return [data, isLoading, error];
}

const isEmptyArray = (arr) => Array.isArray(arr) && arr.length === 0;
